export enum ErrorHandlerType {
  LOG = 'LOG',
  DIALOG = 'DIALOG',
}
